<template>
    <q-layout view="hHh lpR fFf">
        <marketing-nav :mobile-nav-open="mobileNav" @toggle-mobile="mobileNav = !mobileNav" />

        <q-page-container>
            <!-- ============================================================
                 HERO
                 ============================================================ -->
            <section class="mkt-hero-light mkt-hero-watermark" style="padding:80px 0 50px;">
                <div class="mkt-hero-arcs" aria-hidden="true">
                    <svg class="mkt-hero-arc mkt-hero-arc--bl" viewBox="0 0 600 400" preserveAspectRatio="xMinYMax slice">
                        <defs>
                            <linearGradient id="arcGradBL" x1="0%" y1="100%" x2="100%" y2="0%">
                                <stop offset="0%" stop-color="#4F46E5" stop-opacity="0" />
                                <stop offset="38%" stop-color="#4F46E5" stop-opacity="1" />
                                <stop offset="100%" stop-color="#7C3AED" stop-opacity="0" />
                            </linearGradient>
                        </defs>
                        <g stroke="url(#arcGradBL)" stroke-width="0.7" fill="none">
                            <path d="M -50,350 Q 150,220 380,200 T 700,170" />
                            <path d="M -50,358 Q 155,230 385,210 T 700,180" />
                            <path d="M -50,366 Q 160,240 390,220 T 700,190" />
                            <path d="M -50,374 Q 165,250 395,230 T 700,200" />
                            <path d="M -50,382 Q 170,260 400,240 T 700,210" />
                            <path d="M -50,390 Q 175,270 405,250 T 700,220" />
                            <path d="M -50,398 Q 180,280 410,260 T 700,230" />
                            <path d="M -50,406 Q 185,290 415,270 T 700,240" />
                            <path d="M -50,414 Q 190,300 420,280 T 700,250" />
                            <path d="M -50,422 Q 195,310 425,290 T 700,260" />
                            <path d="M -50,430 Q 200,320 430,300 T 700,270" />
                            <path d="M -50,438 Q 205,330 435,310 T 700,280" />
                        </g>
                    </svg>
                    <svg class="mkt-hero-arc mkt-hero-arc--tr" viewBox="0 0 600 400" preserveAspectRatio="xMinYMax slice">
                        <defs>
                            <linearGradient id="arcGradTR" x1="0%" y1="100%" x2="100%" y2="0%">
                                <stop offset="0%" stop-color="#0EA5E9" stop-opacity="0" />
                                <stop offset="38%" stop-color="#0EA5E9" stop-opacity="1" />
                                <stop offset="100%" stop-color="#4F46E5" stop-opacity="0" />
                            </linearGradient>
                        </defs>
                        <g stroke="url(#arcGradTR)" stroke-width="0.7" fill="none">
                            <path d="M -50,350 Q 150,220 380,200 T 700,170" />
                            <path d="M -50,358 Q 155,230 385,210 T 700,180" />
                            <path d="M -50,366 Q 160,240 390,220 T 700,190" />
                            <path d="M -50,374 Q 165,250 395,230 T 700,200" />
                            <path d="M -50,382 Q 170,260 400,240 T 700,210" />
                            <path d="M -50,390 Q 175,270 405,250 T 700,220" />
                            <path d="M -50,398 Q 180,280 410,260 T 700,230" />
                            <path d="M -50,406 Q 185,290 415,270 T 700,240" />
                            <path d="M -50,414 Q 190,300 420,280 T 700,250" />
                            <path d="M -50,422 Q 195,310 425,290 T 700,260" />
                            <path d="M -50,430 Q 200,320 430,300 T 700,270" />
                            <path d="M -50,438 Q 205,330 435,310 T 700,280" />
                        </g>
                    </svg>
                </div>
                <div class="mkt-hero-watermark-icon mkt-hero-watermark-icon--right" aria-hidden="true">
                    <q-icon name="description" />
                </div>
                <div class="mkt-container text-center" style="position:relative;z-index:1;">
                    <span class="mkt-trust-pill mkt-trust-pill--light q-mb-md" style="display:inline-block;">
                        <q-icon name="bolt" class="mkt-trust-icon" /> No subscription &middot; No credit card
                    </span>
                    <h1 class="text-weight-bold q-mt-md q-mb-md" style="font-size:clamp(2rem,4vw,3rem);color:#0F172A;line-height:1.15;">
                        <span class="text-gradient-indigo">3 free signings</span> every month.<br>
                        No credit card required.
                        <span class="visually-hidden"> - Free electronic signatures for individuals from eSign Launchpad</span>
                    </h1>
                    <p class="q-mb-lg" style="font-size:1.1rem;max-width:580px;margin:0 auto;color:#475569;">
                        Send up to <b>3 signings per month free, forever.</b>
                        Additional signings are <b>$4.99 each</b> - no subscription, pay only when you need more.
                        Legally binding in all 50 states.
                    </p>
                    <div class="row justify-center q-gutter-md mkt-hero-cta-row">
                        <q-btn color="primary" size="lg" label="Start Free - No credit card" href="/Account/Register?plan=free"
                            no-caps unelevated style="border-radius:10px;padding:10px 32px;" />
                        <q-btn outline size="lg" no-caps label="See how it works" href="#how-it-works" style="border-radius:10px;padding:10px 32px;color:#334155;border-color:#CBD5E1;" />
                    </div>
                </div>
            </section>

            <!-- ============================================================
                 USE CASES
                 ============================================================ -->
            <section id="how-it-works" class="mkt-white reveal-fade-up" v-intersection="revealCfg" style="padding:60px 0;">
                <div class="mkt-container">
                    <div class="text-center q-mb-xl">
                        <div class="mkt-section-eyebrow">Use cases</div>
                        <h2 class="text-weight-bold q-mb-sm" style="font-size:clamp(1.6rem,3vw,2.2rem);color:#0a0f1a;">Signing one thing, made simple</h2>
                        <p class="text-grey-7" style="font-size:1.05rem;max-width:600px;margin:0 auto;">
                            From signup to sent: about 5 minutes total. Your time in the document editor varies with complexity.
                        </p>
                    </div>
                    <div class="row q-col-gutter-lg">
                        <div class="col-12 col-md-4" v-for="(step, i) in steps" :key="i">
                            <div class="mkt-card q-pa-lg" style="height:100%;">
                                <div class="text-weight-bold q-mb-xs" style="font-size:0.85rem;color:#4F46E5;text-transform:uppercase;letter-spacing:1px;">Step {{ i + 1 }}</div>
                                <h3 class="text-weight-bold q-mb-sm" style="font-size:1.15rem;color:#0a0f1a;">{{ step.title }}</h3>
                                <p class="text-grey-7" style="font-size:0.95rem;line-height:1.6;">{{ step.detail }}</p>
                            </div>
                        </div>
                    </div>
                    <div class="mkt-container-narrow text-center q-mt-xl">
                        <p class="text-grey-7" style="font-size:1rem;line-height:1.7;">
                            <b>Real world example:</b>
                            Got an NDA from a client? A one-off contractor release? A single purchase agreement to sign and return?
                            Upload it, add yourself (and anyone else), send. The other party signs from any device -
                            no account, no download. You get a signed PDF with a full audit trail.
                            Since it's your first this month, you paid <b>$0</b>. No credit card, no subscription.
                        </p>
                    </div>
                </div>
            </section>

            <!-- Free-plan spotlight: most individuals land here because they
                 want the "free forever" story. Reinforces the offer with the
                 actual branded slide before they keep scrolling to features. -->
            <marketing-spotlight
                slug="spot-free"
                alt="eSign Launchpad Free plan card - three signings per month forever with no credit card required"
                eyebrow-icon="celebration"
                icon-circle-class="mkt-icon-circle--green"
                title="Free, forever. No credit card."
                blurb="Three signings every month on the Free plan, every month. Pay $4.99 per signing only if you go over. No upsells, no card on file, no trial-then-billed surprise."
                :bullets="['3 free signings every month, forever', 'No credit card to start, ever', 'Pay-as-you-go overage only when you need it', 'Same audit trail and security as paid plans']"
                cta-label="Start free"
                cta-href="/Account/Register" />

            <!-- ============================================================
                 FEATURES
                 ============================================================ -->
            <section id="features" class="mkt-light reveal-scale" v-intersection="revealCfg" style="padding:60px 0;">
                <div class="mkt-container">
                    <div class="text-center q-mb-xl">
                        <div class="mkt-section-eyebrow">Features</div>
                        <h2 class="text-weight-bold q-mb-sm" style="font-size:clamp(1.6rem,3vw,2.2rem);color:#0a0f1a;">What's included with every signing</h2>
                        <p class="text-grey-7" style="font-size:1.05rem;">Security and compliance built into every signing.</p>
                    </div>
                    <div class="row q-col-gutter-lg">
                        <div class="col-12 col-sm-6 col-md-4" v-for="f in features" :key="f.title">
                            <div class="mkt-card q-pa-lg" style="height:100%;">
                                <q-item class="q-pa-none q-mb-sm">
                                    <q-item-section avatar>
                                        <q-icon :name="f.icon" size="32px" class="text-primary" />
                                    </q-item-section>
                                    <q-item-section>
                                        <q-item-label class="text-weight-bold" style="font-size:1.05rem;color:#0a0f1a;line-height:1.25;">{{ f.title }}</q-item-label>
                                    </q-item-section>
                                </q-item>
                                <p class="text-grey-7 q-mb-none" style="font-size:0.9rem;line-height:1.6;">{{ f.detail }}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <!-- ============================================================
                 PRICING
                 ============================================================ -->
            <section id="pricing" class="mkt-white reveal-fade-up" v-intersection="revealCfg" style="padding:60px 0;">
                <div class="mkt-container-narrow">
                    <div class="text-center q-mb-lg">
                        <div class="mkt-section-eyebrow">Pricing</div>
                        <h2 class="text-weight-bold q-mb-sm" style="font-size:clamp(1.6rem,3vw,2.2rem);color:#0a0f1a;">One tier. Zero commitment.</h2>
                    </div>
                    <div style="max-width:400px;margin:0 auto;">
                        <plan-card tier-code="free"
                                   featured featured-label="For ad-hoc signers"
                                   cta-label="Start Free"
                                   includes-label="Includes:" />
                    </div>
                    <div class="text-center q-mt-lg">
                        <span style="font-size:0.9rem;color:#475569;">Sending more than 4 signings a month?</span>
                        <q-btn flat no-caps color="primary" label="See Small Business plans"
                               icon-right="arrow_forward" href="/Home/SmallBusiness"
                               class="q-ml-sm"
                               style="font-size:0.9rem;font-weight:500;border-radius:8px;" />
                    </div>
                </div>
            </section>

            <!-- ============================================================
                 FINAL CTA
                 ============================================================ -->
            <section class="mkt-cta-gradient reveal-fade-up" v-intersection="revealCfg" style="padding:60px 0;">
                <div class="mkt-container text-center">
                    <h2 class="text-white text-weight-bold q-mb-md" style="font-size:1.8rem;">Get your one thing signed.</h2>
                    <p class="text-white q-mb-lg" style="opacity:0.9;font-size:1rem;">No subscription. No credit card until you send.</p>
                    <q-btn color="white" text-color="primary" size="lg" label="Start Free" href="/Account/Register?plan=free"
                        no-caps unelevated style="border-radius:10px;padding:10px 36px;font-weight:600;" />
                </div>
            </section>

            <marketing-footer />
        </q-page-container>
    </q-layout>
</template>

<script>
import PlanCard from '@components/marketing/PlanCard.vue';
import MarketingNav from '@components/marketing/MarketingNav.vue';
import MarketingFooter from '@components/marketing/MarketingFooter.vue';
import MarketingSpotlight from '@components/marketing/MarketingSpotlight.vue';
import { revealMixin } from '@util/reveal.js';

export default {
    name: 'IndividualsPage',
    mixins: [revealMixin],
    components: { PlanCard, MarketingNav, MarketingFooter, MarketingSpotlight },
    data() {
        return {
            mobileNav: false,
            steps: [
                { title: 'Create a free account', detail: 'Email + password. No credit card. Done in 60 seconds.' },
                { title: 'Upload your document',  detail: 'Drag in a PDF, Word doc, or image. We convert it.' },
                { title: 'Add signers, send, done', detail: 'Drop fields, hit send. Signers sign from any device - no account.' }
            ],
            features: [
                { icon: 'gavel',       title: 'Legally binding',          detail: 'ESIGN Act & UETA compliant in all 50 states.' },
                { icon: 'verified',    title: 'Tamper-evident audit',     detail: 'Hash-chained log catches any change after the fact.' },
                { icon: 'smartphone',  title: 'Mobile-friendly signing',  detail: 'Signers complete on any device. No app, no account.' },
                { icon: 'fingerprint', title: 'Identity verification',    detail: 'SMS, KBA, or government-ID - pay-per-use when stakes are high.' },
                { icon: 'description', title: '3 reusable templates',     detail: 'Save a document with pre-placed fields and reuse it.' },
                { icon: 'lock',        title: 'Bank-level encryption',    detail: '256-bit encryption at rest and in transit. Enterprise cloud infrastructure.' }
            ]
        };
    }
};
</script>

<style scoped>
.mkt-section-eyebrow {
    display: inline-block;
    font-size: 0.8rem;
    font-weight: 700;
    color: #4F46E5;
    text-transform: uppercase;
    letter-spacing: 1px;
    margin-bottom: 6px;
}
</style>
